import { render, staticRenderFns } from "./temoignage.vue?vue&type=template&id=6d874f2f&scoped=true"
import script from "./temoignage.vue?vue&type=script&lang=js"
export * from "./temoignage.vue?vue&type=script&lang=js"
import style0 from "./temoignage.vue?vue&type=style&index=0&id=6d874f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d874f2f",
  null
  
)

export default component.exports